import { FormattedMessage } from 'react-intl';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import type { TotalAveragePlayerScore } from '@sorare/core/src/lib/averagePlayerScore';
import { modeTooltipMessages } from '@sorare/core/src/lib/so5';

const averageScoreLabel = {
  [AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE]: 'L15',
  [AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE]: 'L5',
  [AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE]: 'L10',
  [AveragePlayerScore.SEASON_AVERAGE_SCORE]: 'S. Avg',
  [AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE]: 'L40',
};
type Props = {
  mode: TotalAveragePlayerScore;
  sortable?: boolean;
};
export const AveragePlayerScoreLabel = ({ mode, sortable = true }: Props) => {
  return (
    <Tooltip title={<FormattedMessage {...modeTooltipMessages[mode]} />}>
      <LabelS color={sortable ? undefined : 'var(--c-nd-400)'}>
        {averageScoreLabel[mode]}
      </LabelS>
    </Tooltip>
  );
};
